import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    tempSchool: { Success: false },
    status: 'idle',
    error: null,
};

export const addSchool = createAsyncThunk(
    'tempSchool/createSchool',
    async dynamoData => {
        const response = await axios.post(
            '/createschoolprofile',
            dynamoData.request,
            {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                url: '/createschoolprofile',
                timeout: 30000,
                headers: {
                    authorization: `Bearer ${dynamoData.token}`,
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data;
    }
);
// need to obtain token silently before the API call and remove from availability page

const tempSchoolSlice = createSlice({
    name: 'tempSchool',
    initialState,
    reducers: {
        infoSchool(state, action) {
            const { pk1, displayName, searchName } = action.payload;
            const currentSchool = state.search;
            if (currentSchool) {
                currentSchool.pk1 = pk1;
                currentSchool.displayName = displayName;
                currentSchool.searchName = searchName;
            }
        },
    },
    extraReducers: {
        [addSchool.pending]: (state, action) => {
            state.status = 'loading';
        },
        [addSchool.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            // Add any fetched posts to the array
            console.log(
                'Fetch School: Need to format date into this ' +
                    JSON.stringify(action.payload.Message)
            );
            state.tempSchool = action.payload.Message;
        },
    },
});

export const { infoSchool } = tempSchoolSlice.actions;

export default tempSchoolSlice.reducer;

export const getTempSchool = state => state.tempSchool;
